module.exports = __webpack_public_path__ + "static/media/img12.c2913e9a.jpg";